import React from 'react';
import H2 from '../H2';
import GuideCard from '../GuideCard';
import RichTextParser from '../RichTextParser';
import Paragraph from '../Paragraph';

function MeetGuidesModal({ guides, title }) {

  return (
    <div className=" overflow-y-scroll md:h-[400px]">
      <H2 className="pb-[12px]  text-dark-800" text={title} />
      <div className="gap-8 divide-y pb-5">
        {guides.map((guide) => (
          <div key={guide.id}>
            <GuideCard guide={guide} alignment />
            <div className="pt-6"><RichTextParser >{guide?.attributes?.introduction}</RichTextParser></div>
            <div className='pt-4'>
              <p className='text-dark-500 font-semibold text-base'>Background</p>
              <Paragraph className="" text={guide?.attributes?.background} />
              <p className='text-dark-500 font-semibold text-base pt-4'>Topics</p>
              <Paragraph className="" text={guide?.attributes?.topics?.data?.map((topic) => topic?.attributes?.name).join(", ")} />
              <p className='text-dark-500 font-semibold text-base pt-4'>Languages</p>
              <Paragraph className="" text={guide?.attributes?.languages?.data?.map((language) => language?.attributes?.name).join(", ")} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MeetGuidesModal;
